import React from 'react'

export default function Space({height}) {
  return (
    <div style={{width: "100%", height}}></div>
  )
}
